import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import * as signalR from '@aspnet/signalr';
// import { environment } from 'environments/environment';
import { EnvConfigurationService } from './env-configuration.service';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  environment = this.envConfigurationService.environment;

  counterNotification = new BehaviorSubject<Array<number>>([0,0]);

  private apiURL: string = this.environment.baseUrl + '/notificationHub';
  // private apiURL: string = 'http://localhost:53686/notificationHub'
  private hubConnection: signalR.HubConnection;

  constructor(
    public envConfigurationService: EnvConfigurationService
  ) {
    this.hubConnection = new signalR.HubConnectionBuilder()
      .withUrl(this.apiURL)
      .build();


    this.hubConnection.serverTimeoutInMilliseconds = 100000;

    this.hubConnection.onclose(() => {
      setTimeout(() => {
        try {
          this.startSignalRConnection(this.hubConnection);
        } catch (ex) {
          console.warn(ex);
        }
      }, 5000);
    });

    this.hubConnection.on("CounterErrorTransaction", (data: Array<number>) => {
      this.counterNotification.next(data);
    });

    this.startSignalRConnection(this.hubConnection);
  }

  private startSignalRConnection = (connection: signalR.HubConnection) => connection.start()
    .then(() => console.warn('Websocket Connection Established'))
    .catch(err => console.error('SignalR Connection Error: ', err))
}
